import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/shared/helpers/cn';
import styles from './Textarea.module.scss';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

/** Campo de texto longo — observacoes, conduta, descricao. */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid, className, rows = 4, ...rest },
  ref,
) {
  return (
    <textarea ref={ref} rows={rows} className={cn(styles.textarea, invalid && styles.invalid, className)} {...rest} />
  );
});
